import { createContext } from 'react';

export const DeleteEntityModalContext = createContext(null);
